// extracted by mini-css-extract-plugin
export default {"myWorks":"works_myWorks__R6EZJ","filter":"works_filter__QxjaQ","active":"works_active__Q6ixX","portfolio_img_wrapper":"works_portfolio_img_wrapper__b6BT7"};